// import { gsap } from "gsap"
// import { ScrollTrigger } from "gsap/ScrollTrigger"
// import { lozad } from "lozad"
// import BigPicture from 'bigpicture'
import sidePanel from "side-panel-menu-thing";

const { $ } = window;

const $body = $(document.body);

export default {
  init() {
    // gsap.registerPlugin(ScrollTrigger)

    if($body.hasClass('page-id-81')) {
      $('.directory-search-cards-card-img img').each((_i, img) => {
        console.log(img.src)
        if(img.src) {
          img.src = img.src.replace('-150x150', '')
          img.srcset = img.srcset.replace('-150x150', '')
          console.log(img.src)
        }
      })
    }

    if ($body.hasClass("admin-bar")) {
      const mobileMenu = new sidePanel({
        target: $body[0],
        props: {
          target: $body[0],
          content: document.getElementById("mobile-menu"),
          fixed: true,
          width: 320,
        },
      });
      $("#toggle_nav").on("click", mobileMenu.show);

      $(document).on(
        "click",
        ".menu-section .menu-item-has-children > a",
        function (e) {
          e.preventDefault();
          let $el = $(this);
          $el.parent().toggleClass("show-subnav");
        }
      );

      function myFunction(x) {
        if (x.matches) { // If media query matches
          mobileMenu.hide()
        }
      }
      
      var x = window.matchMedia("(min-width: 1148.5px)")
      myFunction(x);
      x.addEventListener("change", function() {
        myFunction(x);
      });

    }
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // class to hide outlines if not using keyboard
    $body.on("mousedown", function () {
      $body.addClass("using-mouse");
    });
    $body.on("keydown", function () {
      $body.removeClass("using-mouse");
    });

    $('#mobile-menu').removeClass("loading");

    handleBannerClose();
  },
};

function mobileMenu() {
  let $mobileMenu = $("#mobile-menu");
  $mobileMenu.hide();
  $mobileMenu.removeClass("loading");
  $("#mobile-menu .menu-item-has-children").find(".sub-menu").hide();
  let showing = false;
  $("#toggle_nav").on("click", () => {
    $mobileMenu.fadeToggle(350);
    setTimeout(() => $("html").toggleClass("mm-open"), 200);
  });
  let current,
    t,
    duration = 250;
  $("#mobile-menu .menu-item-has-children > *:first-child").click((e) => {
    e.preventDefault();
    if (t) {
      return;
    }

    e.target.classList.toggle("menu-open");
    $(e.target).parent().toggleClass("menu-open");

    //hide previous
    if (current) {
      //open menu
      if (!current.includes(e.target.innerText)) {
        //different from open
        $("#mobile-menu .menu-item-has-children > *:first-child")
          .parent()
          .find(".sub-menu")
          .fadeOut(duration);
        $("#mobile-menu .menu-item-has-children > *:first-child").removeClass(
          "menu-open"
        );
        current = e.target.innerText;
        //show respective
        setTimeout(() => {
          $(e.target).parent().find(".sub-menu").fadeToggle(duration);
        }, duration - 100);
      } else {
        //closing open menu
        $(e.target).parent().find(".sub-menu").fadeToggle(duration);
        $(e.target).removeClass("menu-open");
        current = null;
      }
    } else {
      //no open menu
      $(e.target).parent().find(".sub-menu").fadeToggle(duration);
      current = e.target.innerText;
    }

    // space out events
    t = setTimeout(() => {
      t = null;
    }, 100);
  });
  let x = window.matchMedia("(max-width: 1100px)");
  toggleMenu(x);
  x.addListener(toggleMenu);
  function toggleMenu(x) {
    if (!x.matches) {
      $mobileMenu.hide();
      $("html").removeClass("mm-open");
    }
  }
}

function detectswipe(el, func) {
  let swipe_det = new Object();
  swipe_det.sX = 0;
  swipe_det.sY = 0;
  swipe_det.eX = 0;
  swipe_det.eY = 0;
  // var min_x = 20;  //min x swipe for horizontal swipe
  var max_x = 40; //max x difference for vertical swipe
  var min_y = 70; //min y swipe for vertical swipe
  // var max_y = 2000;  //max y difference for horizontal swipe
  var direc = "";
  let ele = document.getElementById(el);
  ele.addEventListener(
    "touchstart",
    function (e) {
      var t = e.touches[0];
      swipe_det.sX = t.screenX;
      swipe_det.sY = t.screenY;
    },
    false
  );
  ele.addEventListener(
    "touchmove",
    function (e) {
      e.preventDefault();
      var t = e.touches[0];
      swipe_det.eX = t.screenX;
      swipe_det.eY = t.screenY;
    },
    false
  );
  ele.addEventListener(
    "touchend",
    function (e) {
      //horizontal detection
      //   if ((((swipe_det.eX - min_x > swipe_det.sX) || (swipe_det.eX + min_x < swipe_det.sX)) && ((swipe_det.eY < swipe_det.sY + max_y) && (swipe_det.sY > swipe_det.eY - max_y)))) {
      // 	 if(swipe_det.eX > swipe_det.sX) direc = "r";
      // 	 else direc = "l";
      //   }
      //vertical detection
      if (
        (swipe_det.eY - min_y > swipe_det.sY ||
          swipe_det.eY + min_y < swipe_det.sY) &&
        swipe_det.eX < swipe_det.sX + max_x &&
        swipe_det.sX > swipe_det.eX - max_x
      ) {
        if (swipe_det.eY < swipe_det.sY) {
          $("html").removeClass("mm-open");
          $("#mobile-menu").fadeToggle(350);
        }
      }

      if (direc != "") {
        if (typeof func == "function") func(el, direc);
      }
      direc = "";
    },
    false
  );
}

function myfunction(el, d) {
  // alert("you swiped on element with id '"+el+"' to "+d+" direction");
}

//  detectswipe('mobile-menu', myfunction);

function intObserve() {
  const onIntersection = (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        //  console.log(entry);
      }
    }
  };

  const observer = new IntersectionObserver(onIntersection);
  document.querySelectorAll(".post-cards--grid-wrap").forEach((el) => {
    observer.observe(el);
  });
}

function handleBannerClose() {
  const $banner = $(".banner");
  if (!$banner.length) {
     return;
  }

  const $close = $banner.find(".banner__close");
  const $content = $banner.find(".banner__content");
  const sessionStorageTokenKey = "bannerClosed";
  const timestamp = getSessionToken(sessionStorageTokenKey);
  console.log(timestamp)


  //show is session storage is not set
  if (!timestamp) {
     // setTimeout(() => {
     $banner.slideDown();
     // }, 1000);
  }

  $close.on("click", () => {
     $banner.slideUp();

     // Set the token
     setSessionToken(sessionStorageTokenKey);
  });
}

function setSessionToken(sessionStorageTokenKey) {
  const now = new Date().getTime();
  // const tokenData = {
  //    value: token,
  //    timestamp: now
  // };
  sessionStorage.setItem(sessionStorageTokenKey, now); //tokenData);
}

function getSessionToken(sessionStorageTokenKey) {
  const tokenData = JSON.parse(sessionStorage.getItem(sessionStorageTokenKey));
  console.log(tokenData)
  
  if (tokenData) {
     const now = new Date().getTime();
     const oneDayInMs = 24 * 60 * 60 * 1000;
     
     // Check if the token is older than 1 day
     if (now - tokenData.timestamp > oneDayInMs) {
        console.log(tokenData)
        sessionStorage.removeItem(sessionStorageTokenKey); // Remove expired token
        return null; // Token has expired
     }

     return tokenData; // Return the valid token timestamp
  }

  return null; // No token found
}